var map = {
	"./allianz.png": 795,
	"./april.jpg": 796,
	"./asisa.jpg": 797,
	"./europ.jpg": 798,
	"./europ.png": 799,
	"./europ.svg": 800,
	"./inter.jpg": 801,
	"./liberty.png": 802,
	"./lusitania.jpg": 803,
	"./mapfre.png": 804,
	"./metlife.png": 805,
	"./prevoir.png": 806,
	"./zurich.svg": 807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 794;